import { render, staticRenderFns } from "./AppGeneral.vue?vue&type=template&id=7752e0b8&scoped=true"
import script from "./AppGeneral.vue?vue&type=script&lang=ts"
export * from "./AppGeneral.vue?vue&type=script&lang=ts"
import style0 from "./AppGeneral.vue?vue&type=style&index=0&id=7752e0b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7752e0b8",
  null
  
)

export default component.exports